<template>
  <div>
    <v-card>
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item :to="`/datasets/${dataset.id}/forms/modifyDatasetForm`">
            <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
            {{ $t("dataset.forms.modifyDataset") }}
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-card class="mt-4 pa-6">
      <DatasetFields :dataset="dataset" :editor-ready="loaded" readonly />
      <div class="text-center mt-6">
        <v-btn text @click="$router.go(-1)"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
        <DeleteObjectForm url-objects="dataset" object_type="dataset" :headers="headers" :item="dataset" />
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import DatasetFields from "./DatasetFields.vue";
import DeleteObjectForm from "@/components/delete_object/DeleteObjectForm";
import { createDefaultDataset, normalizeDataset } from "@/utils/dataset";

export default {
  name: "DetailDataset",
  components: { DatasetFields, DeleteObjectForm },
  data: () => ({ dataset: createDefaultDataset(), loaded: false }),
  computed: {
    headers() {
      return [{ text: this.$t("form.dataset_title"), value: "title" }];
    }
  },
  created() {
    axios.get(`${this.$store.state.endpoint}/user/dataset/${this.$route.params.id}`)
      .then(response => {
        this.dataset = normalizeDataset(response.data);
        this.$store.state.sectionTitle = this.dataset.title;
      })
      .catch(error => console.error(error))
      .finally(() => { this.loaded = true; });
  }
};
</script>
